import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Loader } from '../../common'
import PastBookingsTable from '../../containers/PastBookingsTable'

import * as bookingSystemActions from '../../actions/BookingSystems'
import * as dataActions from '../../actions/Data'

class PastBookings extends React.Component {
  componentDidMount() {
    const { data } = this.props

    this.fetch()
  }

  fetch() {
    const { user, data } = this.props

    if (!data.bookingSystemsFetched) {
      this.props.tryGetBookingSystem(user.token, data.community.id)
    }
  }

  renderContent() {
    const { data } = this.props
    const systems = data.bookingSystems

    return systems.map(item => {
      const system = item.bookableObject

      return <PastBookingsTable system={system} key={system.id} />
    })
  }

  render() {
    const { classes, data } = this.props

    if (!data.bookingSystemsFetched) {
      return (
        <main className={classes.content}>
          <Loader />
        </main>
      )
    }

    return (
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {this.renderContent()}
      </main>
    )
  }
}

const Styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto'
  }
})

PastBookings.propTypes = {
  classes: PropTypes.object.isRequired
}

function mapStateToProps({ data, user }) {
  return { data, user }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...dataActions, ...bookingSystemActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PastBookings)



// WEBPACK FOOTER //
// ./src/components/pages/PastBookings/index.js